import { render, staticRenderFns } from "./InsureSignature.vue?vue&type=template&id=1c7805bf&"
import script from "./InsureSignature.vue?vue&type=script&lang=js&"
export * from "./InsureSignature.vue?vue&type=script&lang=js&"
import style0 from "./InsureSignature.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports